import { render, staticRenderFns } from "./groupRelationDevice.vue?vue&type=template&id=cf19e3d8&scoped=true"
import script from "./groupRelationDevice.vue?vue&type=script&lang=ts"
export * from "./groupRelationDevice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf19e3d8",
  null
  
)

export default component.exports